import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { FirebaseUserModel } from '../core/user.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { DialogOverviewExampleDialogComponent } from './home.component.dialog';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss']
})
export class HomeComponent implements OnInit {
  user: FirebaseUserModel = new FirebaseUserModel();
  public items: any;
  public orderedItems: any;
  private REST_API_SERVER = 'https://us-central1-alliancecourses.cloudfunctions.net/getRegistrationDate';
  dayArray = [];

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private fb: FormBuilder,
    private db: AngularFirestore,
    private httpClient: HttpClient,
    public dialog: MatDialog
  ) {

  }

  ngOnInit() {
    this.route.data.subscribe(routeData => {
      const data = routeData.data;
      if (data) {
        this.user = data;
        this.items = this.db.collection('tickets').valueChanges();
      }
    });
    this.getItems();

    this.sendGetRequest().subscribe((dataHttp: any[]) => {
      this.dayArray = dataHttp;
    });
  }

  sendGetRequest() {
    return this.httpClient.get(this.REST_API_SERVER);
  }

  getItems = () => {
    this.items.subscribe(item => this.orderItems(item));
  }

  orderItems = (items: any) => {
    // items.sort((a, b) => (a.color > b.color) ? 1 : -1);
    this.orderedItems = items.sort((a, b) => (a.starttime > b.starttime) ? 1 : -1);
  }

  openDialog = (item: any) => {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '500px',
      height: '800px',
      data: {
        course: item.course,
        teacher: item.teacher,
        starttime: item.starttime,
        endtime: item.endtime,
        capacity: item.capacity,
        user: this.user.email,
        uid: item.uid,
        day: item.day,
        date: item.date,
        likes: item.likers ? item.likers.length : 0,
        likers: item.likers ? item.likers : [],
        dayArray: this.dayArray
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
    });
  }
}
